
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bkJCN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79cc293790306d2c61f9451b180abc1c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8404f410d40d95df$var$_react = $8404f410d40d95df$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8404f410d40d95df$var$_baseNew = $8404f410d40d95df$var$_interopRequireDefault((parcelRequire("gElAV")));
function $8404f410d40d95df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Shortcut".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/shortcut
 * Usage guidance:
 * Single purpose - Reserved for shortcuts in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8404f410d40d95df$var$ShortcutIcon = (props)=>/*#__PURE__*/ $8404f410d40d95df$var$_react.default.createElement($8404f410d40d95df$var$_baseNew.default, Object.assign({
        name: "ShortcutIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.25 2.25V0h1.5v2.25H16v1.5h-2.25V6h-1.5V3.75H10v-1.5zM3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8.5H15V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h4.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$8404f410d40d95df$var$ShortcutIcon.displayName = 'ShortcutIcon';
var $8404f410d40d95df$var$_default = module.exports.default = $8404f410d40d95df$var$ShortcutIcon;

});


//# sourceMappingURL=shortcut.11b1e0c1.js.map
